<template>
  <div class="top-nav-main" :style="navStyleVars">
    <div class="top-nav-container">
      <div class="top-nav">
        <div
          class="top-nav-menu-container"
          @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
          @mouseleave="handleShowOperationBtn(false)"
        >
          <div class="top-nav-menu-logo">
            <a :href="indexHrefUrl"
              ><img
                :src="configDataForm.leftLogoImageFullUrl || noUpload"
                fit="cover"
            /></a>
          </div>
          <div class="top-nav-menu-list">
            <span class="menu-close" @click="handleShowMoreMenu"> </span>
            <span
              v-for="item in configDataForm.columnList"
              :key="item.id"
              :class="{
                active: item.id == activeIndex,
                'top-nav-menu-list-item': true,
              }"
            >
              <span class="menu-item-icon">
                <img
                  v-if="item.data && item.data.iconUrl"
                  :src="item.data.iconUrl || noUpload"
                  fit="cover"
                />
              </span>
              <a
                v-if="item.children && item.children.length > 0"
                :href="item.children[0].data.hrefURL"
              >
                {{ item.label }}
              </a>
              <a
                v-else-if="item.data"
                :href="item.data.hrefURL"
                :title="item.data.hrefURL"
              >
                {{ item.label }}
              </a>
              <div
                v-if="item.children && item.children.length > 0"
                class="sub-menu"
              >
                <ul class="sub-nav">
                  <li></li>
                  <li
                    v-for="subitem in item.children"
                    :key="'su-el' + item.id + '-' + subitem.id"
                  >
                    <a v-if="subitem.data" :href="subitem.data.hrefURL">
                      {{ subitem.label }}
                    </a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
          <div class="top-nav-more-menu" @click="handleShowMoreMenu"></div>
          <operation-container
            v-if="showOperationBtn && !showEditForm"
            :component-data="props.componentData"
            :show-edit-content-button="props.showEditContentButton"
            :show-edit-components-button="props.showEditComponentsButton"
            :show-delete-components-button="props.showDeleteComponentsButton"
            :show-insert-components-button="props.showInsertComponentsButton"
            :show-sort-components-button="props.showSortComponentsButton"
            @handle-show-edit-form="handleShowEditForm"
            @handle-change-components="handleChangeComponents"
            @handle-delete-components="handleDeleteComponents"
            @handle-insert-components="handleInsertComponents"
            @handle-sort-components="handleSortComponents"
          ></operation-container>
        </div>
      </div>
      <div class="top-nav">
        <div
          class="top-nav-menu-container"
          @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
          @mouseleave="handleShowOperationBtn(false)"
        >
          <div class="top-nav-menu-logo">
            <a :href="indexHrefUrl"
              ><img
                :src="configDataForm.leftLogoImageFullUrl || noUpload"
                fit="cover"
            /></a>
          </div>
          <div
            class="top-nav-menu-list-mask-layer"
            :class="{ show: showMobileMenuList }"
          ></div>
          <div class="top-nav-menu-list" :class="{ show: showMobileMenuList }">
            <div class="menu-panel-header">
              <div class="menu-panel-logo">
                <a :href="indexHrefUrl"
                  ><img
                    :src="configDataForm.leftLogoImageFullUrl || noUpload"
                    fit="cover"
                /></a>
              </div>
              <span class="menu-close" @click="handleShowMoreMenu"></span>
            </div>
            <span
              v-for="item in mobileColumnList"
              :key="item.id"
              :class="{
                active: item.id == activeIndex && item.showSubMenu,
                'top-nav-menu-list-item': true,
                'sub-menu-open': item.showSubMenu,
              }"
            >
              <a
                v-if="item.children && item.children.length > 0"
                class="menu-item-text"
                @click="handleToggleShowSubMenu(item)"
              >
                <img
                  v-if="item.data && item.data.iconUrl"
                  class="menu-item-icon"
                  :src="item.data.iconUrl"
                />
                <span>{{ item.label }}</span>
              </a>
              <a
                v-else-if="item.data"
                class="menu-item-text-single"
                :href="item.data.hrefURL"
              >
                <img
                  v-if="item.data && item.data.iconUrl"
                  class="menu-item-icon"
                  :src="item.data.iconUrl"
                />
                <span>{{ item.label }}</span>
              </a>
              <div
                v-if="item.children && item.children.length > 0"
                class="sub-menu"
              >
                <ul class="sub-nav">
                  <li
                    v-for="subitem in item.children"
                    :key="'su-el' + item.id + '-' + subitem.id"
                  >
                    <a v-if="subitem.data" :href="subitem.data.hrefURL">
                      {{ subitem.label }}
                    </a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
          <div class="top-nav-more-menu" @click="handleShowMoreMenu"></div>
        </div>
      </div>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <top-nav-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></top-nav-edit-form>
    </el-drawer>
  </div>
</template>

<script setup>
// #region 引用
import TopNavEditForm from './TopNavEditFormOne.vue';
import OperationContainer from '../common/OperationContainer.vue';

// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;
// 默认选中key
// const activeIndex = ref('1');
// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);
// #endregion
// 创建变量设默认值
const configDataForm = ref('');
// 是否移动菜单列表样式
const showMobileMenuList = ref(false);

// #region 生命周期

if (props.componentData.configData) {
  // ssr服务器渲染直接调用
  configDataForm.value = JSON.parse(props.componentData.configData);
  // 后端编辑内容存在数据更新问题处理
  // 待数据更新完成后再执行
  if (props.componentData !== 3) {
    nextTick(() => {
      configDataForm.value = JSON.parse(props.componentData.configData);
    });
  }
}

// 默认选中key
const activeIndex = computed(() => {
  if (configDataForm.value.activeIndex) {
    let id = configDataForm.value.activeIndex;
    configDataForm.value.columnList?.forEach((element) => {
      element.children?.forEach((item) => {
        if (item.id === Number(configDataForm.value.activeIndex) && item.data) {
          id = item.data.parentId;
        }
      });
    });
    return `${id.toString()}`;
  }
  return configDataForm.value.columnList[0].id.toString();
});

// 首页链接
const indexHrefUrl = computed(() => {
  return configDataForm.value.columnList[0].data
    ? configDataForm.value.columnList[0].data.hrefURL
    : configDataForm.value.columnList[0].hrefURL;
});

// 移动端当前展开的一级菜单 id（互斥：同一时间只能展开一个）
// 默认展开当前栏目所属的一级菜单
const expandedSubMenuId = ref(activeIndex.value);

// 移动端栏目列表（带子菜单展开状态）
const mobileColumnList = computed(() => {
  return configDataForm.value.columnList.map((item) => {
    return {
      ...item,
      showSubMenu: expandedSubMenuId.value === item.id.toString(),
    };
  });
});

// 导航栏背景色/字体色（支持后台配置，未配置时使用默认值，避免影响历史数据）
const hexToRgba = (hex, alpha) => {
  if (!hex) return null;
  const m = hex.replace('#', '');
  const full =
    m.length === 3
      ? m
          .split('')
          .map((c) => c + c)
          .join('')
      : m;
  if (full.length !== 6) return null;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return null;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
const navStyleVars = computed(() => {
  const fontColor = configDataForm.value.navFontColor || '#ffffff';
  return {
    '--nav-bg-color': configDataForm.value.navBgColor || '#334d60',
    '--nav-font-color': fontColor,
    // 选中项下划线、二级栏目分隔线：跟随字体色并降低透明度
    '--nav-line-color':
      hexToRgba(fontColor, 0.4) || 'rgba(255, 255, 255, 0.4)',
    // 二级菜单字体色：比主字体色暗一点（移动端二级、PC 端二级 hover）
    '--nav-font-color-mute':
      hexToRgba(fontColor, 0.7) || 'rgba(255, 255, 255, 0.7)',
  };
});

// #endregion

// #region 业务方法

const handleShowMoreMenu = (e) => {
  showMobileMenuList.value = !showMobileMenuList.value;
};

const handleToggleShowSubMenu = (item) => {
  const id = item.id.toString();
  expandedSubMenuId.value = expandedSubMenuId.value === id ? null : id;
};

// 操作显不显示编辑内容按钮
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style lang="scss">
.top-nav-main {
  // 建立 BFC，containment 菜单容器的上下外边距，避免外边距合并导致占位高度小于视觉高度、下方内容被遮挡
  display: flow-root;
  position: relative;
  width: 100%;
}
.top-nav-container {
  width: 100%;
  // 导航栏不使用 fixed/absolute，回归常规流（与移动端一致），
  // 占据自身高度，避免覆盖下方内容。PC/移动两套导航的按端显隐
  // 通过 .top-nav:first-child / :last-child 结构选择器控制。
}
</style>

<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* PC端样式 */
@include pc {
  .top-nav {
    width: 100%;
    // 上下间距用 padding（而非子元素 margin），让深色背景覆盖整个导航高度，避免上下白色间隙
    // 上下对称，使 logo 在导航栏中垂直居中
    padding: 15px 0;
    background-color: var(--nav-bg-color, #334d60);
    transition: all $website-duration-normal $website-ease-out;

    .top-nav-menu-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;

      .top-nav-menu-logo {
        height: 80px;
        margin-right: 20px;

        img {
          height: 100%;
        }
      }
      // 导航菜单
      .top-nav-menu-list {
        display: flex;
        flex-wrap: wrap;

        .top-nav-menu-list-item {
          position: relative;
          display: flex;
          flex: auto;
          align-content: center;
          align-items: center;
          padding-bottom: 10px;
          margin: 18px 4px;
          font-family:
            '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          letter-spacing: 1px;
          cursor: pointer;

          .menu-item-icon {
            display: none;
          }
          // 下级菜单样式
          .sub-menu {
            position: absolute;
            top: 100%;
            left: -9px;
            z-index: 2;
            display: none;
            min-width: 120px;
            background-color: var(--nav-bg-color, #334d60);
            box-shadow: 0 5px 8px rgb(0 0 0 / 10%);
            opacity: 0;
            transition: opacity $website-duration-fast $website-ease-out;

            ul {
              z-index: 10;
              width: 100%;
              li:first-of-type {
                height: 1px;
                background: var(--nav-line-color, rgba(255, 255, 255, 0.4));
              }

              li:not(:last-of-type) {
                border-bottom: 1px solid
                  var(--nav-line-color, rgba(255, 255, 255, 0.4));
              }

              li {
                z-index: 1;
                height: 36px;
                border-bottom: 1px solid
                  var(--nav-line-color, rgba(255, 255, 255, 0.4));
              }

              li a {
                display: block;
                padding: 0 18px 0 21px;
                overflow: hidden;
                font-size: 14px;
                line-height: 36px;
                color: var(--nav-font-color, #ffffff);
                text-align: left;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              li:not(:first-of-type):hover {
                color: var(--nav-font-color-mute, rgba(255, 255, 255, 0.7));
                background-color: color-mix(
                  in srgb,
                  var(--nav-font-color, #fff) 12%,
                  transparent
                );
                a {
                  color: var(--nav-font-color-mute, rgba(255, 255, 255, 0.7));
                }
              }
            }
          }
        }

        .top-nav-menu-list-item a {
          color: var(--nav-font-color, #fff);
        }

        .top-nav-menu-list-item.active {
          color: $website-primary;
          border-bottom: 2px solid var(--nav-line-color, rgba(255, 255, 255, 0.4));
        }
        .top-nav-menu-list-item:hover {
          .sub-menu {
            display: block;
            opacity: 1;
          }
        }

        .top-nav-menu-list-item.active a {
          color: var(--nav-font-color, #fff);
        }
      }
    }

    .top-nav-more-menu {
      display: none;
    }
  }
  // PC 端隐藏移动端备用导航，避免两套导航同时渲染导致 logo 占位图重复
  .top-nav-container > .top-nav:last-child {
    display: none;
  }
}

/* 移动端样式 */
@include mobile {
  .top-nav {
    width: 100% !important;
    min-width: auto !important;
    height: 16vw;
    background-color: var(--nav-bg-color, #334d60);
    transition: all $website-duration-normal $website-ease-out;

    .top-nav-menu-container {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: normal;
      justify-content: flex-start;
      margin: 0;

      .top-nav-menu-logo {
        display: flex;
        justify-content: flex-start;
        margin-top: 2vw;
        img {
          height: 12vw;
          margin-left: 2vw;
        }
      }

      .top-nav-menu-list-mask-layer {
        display: none;
        width: 100%;
        height: 100vh;
        background-color: #666;
        opacity: 0.6;
      }

      .top-nav-menu-list-mask-layer.show {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9998;
        display: block;
      }

      .top-nav-menu-list {
        display: none;
      }

      .top-nav-menu-list.show {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        padding: 2vw 4vw;
        overflow-y: auto;
        background-color: var(--nav-bg-color, #334d60);
        backdrop-filter: blur(20px);
        animation: slideInFromRight 0.35s cubic-bezier(0.4, 0, 0.2, 1);

        &.hiding {
          animation: slideOutToRight 0.25s cubic-bezier(0.4, 0, 1, 1);
        }

        // 顶部头部区：左 logo + 右关闭按钮
        .menu-panel-header {
          display: flex;
          flex-shrink: 0;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: 1vw 0 2vw;

          .menu-panel-logo {
            img {
              height: 12vw;
            }
          }
        }

        .menu-close {
          position: relative;
          top: auto;
          right: auto;
          display: flex;
          width: 10vw;
          height: 10vw;
          cursor: pointer;
          background-color: color-mix(
            in srgb,
            var(--nav-font-color, #fff) 10%,
            transparent
          );
          border-radius: 50%;
          transition:
            transform 0.25s cubic-bezier(0, 0, 0.2, 1),
            background-color 0.15s;

          // 纯 CSS 绘制 × 关闭图标，颜色跟随导航栏字体色
          &::before,
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 55%;
            height: 0.9vw;
            background: var(--nav-font-color, #fff);
            border-radius: 1vw;
          }

          &::before {
            transform: translate(-50%, -50%) rotate(45deg);
          }

          &::after {
            transform: translate(-50%, -50%) rotate(-45deg);
          }

          &:hover {
            background-color: color-mix(
              in srgb,
              var(--nav-font-color, #fff) 18%,
              transparent
            );
            transform: rotate(90deg);
          }

          &:active {
            opacity: 0.6;
          }
        }

        .top-nav-menu-list-item {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding-left: 4vw;
          font-size: 4.5vw;
          border-bottom: 1px solid var(--nav-line-color, rgba(255, 255, 255, 0.4));

          .menu-item-text-single,
          .menu-item-text {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 2vw;
            width: 100%;
            height: 16vw;
            padding-right: 4vw;
            font-weight: 700;
            color: var(--nav-font-color, #ffffff);
            cursor: pointer;
            transition:
              background-color 0.15s,
              transform 0.15s;

            &:active {
              background-color: rgb(0 0 0 / 4%);
              transform: scale(0.98);
            }
          }

          // 一级菜单图标
          .menu-item-icon {
            flex-shrink: 0;
            width: 6vw;
            height: 6vw;
            object-fit: cover;
          }

          .menu-item-text::after {
            position: absolute;
            right: 4vw;
            display: flex;
            width: 8px;
            height: 8px;
            content: '';
            border-right: 2px solid var(--nav-font-color, #ffffff);
            border-bottom: 2px solid var(--nav-font-color, #ffffff);
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            transform: rotate(45deg);
          }

          .sub-menu {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;
            max-height: 0;
            padding-left: 4vw;
            overflow: hidden;
            background-color: rgb(0 0 0 / 3%);
            transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);

            ul {
              width: 100%;

              li:not(:last-of-type) {
                border-bottom: 1px solid
                  var(--nav-line-color, rgba(255, 255, 255, 0.4));
              }

              li {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                height: 12vw;
                padding-left: 2vw;

                a {
                  font-size: 3.5vw;
                  color: var(--nav-font-color-mute, rgba(255, 255, 255, 0.7));
                  transition: opacity 0.15s;

                  &:active {
                    opacity: 0.7;
                  }
                }
              }
            }
          }
        }

        .top-nav-menu-list-item.active {
          background-color: rgb(25 66 148 / 6%);

          .menu-item-text {
            color: var(--nav-font-color-mute, rgba(255, 255, 255, 0.7));

            &::after {
              border-color: var(--nav-font-color-mute, rgba(255, 255, 255, 0.7));
            }
          }
        }

        // 展开态（独立于路由选中态）：点击任意带子菜单的一级菜单都能展开/折叠
        .top-nav-menu-list-item.sub-menu-open {
          .sub-menu {
            max-height: 300px;
          }

          .menu-item-text::after {
            transform: rotate(-135deg);
          }
        }
      }

      .top-nav-more-menu {
        position: absolute;
        top: 50%;
        right: 2vw;
        display: flex;
        width: 10vw;
        height: 10vw;
        cursor: pointer;
        // 纯 CSS 绘制三条横线（汉堡键），颜色跟随导航栏字体色
        background-image:
          linear-gradient(var(--nav-font-color, #fff), var(--nav-font-color, #fff)),
          linear-gradient(var(--nav-font-color, #fff), var(--nav-font-color, #fff)),
          linear-gradient(var(--nav-font-color, #fff), var(--nav-font-color, #fff));
        background-size: 100% 1.1vw;
        background-position: center 22%, center 50%, center 78%;
        background-repeat: no-repeat;
        transition:
          opacity 0.15s,
          transform 0.25s;
        transform: translateY(-50%);

        &:hover {
          transform: translateY(-50%) scale(1.1);
        }

        &:active {
          opacity: 0.6;
        }
      }
    }
  }
  // 移动端隐藏 PC 端导航，按端只保留一套导航
  .top-nav-container > .top-nav:first-child {
    display: none;
  }
}
</style>
